import { httpRequest } from '@/utils/request';
import { CommonResponse, TableReponseType, TableRequestType } from '@/types';

// 固件：后端 models.Firmware 无 json tag，序列化为 PascalCase。
export interface Firmware {
  Id: string;
  Name: string;
  Version: string;
  FileName: string;
  FileSize: number;
  ChunkSize: number;
  ChunkCount: number;
  ObjectKey: string;
  SHA256: string;
  CRC32: number;
  ProductId: string;
  DeviceModel: string;
  Description: string;
  Status: string;
  Created: number;
  Modified: number;
}

// 任务：后端 models.OtaJob 无 json tag，序列化为 PascalCase。
export interface OtaJob {
  Id: string;
  FirmwareId: string;
  Status: string;
  TotalDevices: number;
  SuccessCount: number;
  FailedCount: number;
  RetryMax: number;
  CreatedBy: string;
  Created: number;
  Modified: number;
}

// 任务详情：dtos 有 json tag，序列化为 camelCase。
export interface OtaJobInfo {
  id: string;
  firmwareId: string;
  status: string;
  totalDevices: number;
  successCount: number;
  failedCount: number;
}

export interface OtaDeviceTaskDetail {
  deviceId: string;
  deviceName: string;
  status: string;
  currentChunk: number;
  totalChunks: number;
  progress: number;
  errorMessage: string;
}

export interface OtaJobDetail {
  job: OtaJobInfo;
  tasks: OtaDeviceTaskDetail[];
}

// 设备活动任务（models.OtaDeviceTask，PascalCase）。
export interface OtaDeviceTask {
  Id: string;
  JobId: string;
  DeviceId: string;
  Status: string;
  CurrentChunk: number;
  TotalChunks: number;
  ErrorMessage: string;
}

export function uploadFirmware(data: FormData) {
  return httpRequest<any, CommonResponse<Firmware>>({
    url: '/api/v1/ota/firmware',
    method: 'post',
    data,
  });
}

export function getFirmwares(params: TableRequestType & { name?: string; version?: string }) {
  return httpRequest<any, CommonResponse<TableReponseType<Firmware>>>({
    url: '/api/v1/ota/firmwares',
    params,
  });
}

export function deleteFirmware(firmwareId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/ota/firmware/${firmwareId}`,
    method: 'delete',
  });
}

export interface OtaJobCreateReq {
  firmwareId: string;
  deviceIds: string[];
  retryMax: number;
  autoStart: boolean;
}

export function createOtaJob(data: OtaJobCreateReq) {
  return httpRequest<any, CommonResponse<OtaJob>>({
    url: '/api/v1/ota/job',
    method: 'post',
    data,
  });
}

export function startOtaJob(jobId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/ota/job/${jobId}/start`,
    method: 'post',
  });
}

export function cancelOtaJob(jobId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/ota/job/${jobId}/cancel`,
    method: 'post',
  });
}

export function retryOtaJob(jobId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/ota/job/${jobId}/retry`,
    method: 'post',
  });
}

export function getOtaJobs(params: TableRequestType & { status?: string }) {
  return httpRequest<any, CommonResponse<TableReponseType<OtaJob>>>({
    url: '/api/v1/ota/jobs',
    params,
  });
}

export function getOtaJobDetail(jobId: string) {
  return httpRequest<any, CommonResponse<OtaJobDetail>>({
    url: `/api/v1/ota/job/${jobId}`,
  });
}

export function getDeviceOtaStatus(deviceId: string) {
  return httpRequest<any, CommonResponse<OtaDeviceTask>>({
    url: `/api/v1/ota/device/${deviceId}/status`,
  });
}
